import useVAT from '@components/_hooks/useVAT';
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import SwitchDetailedLabel from '../Reusables/Components/SwitchDetailedLabel';

export default function VatToggle(props) {
    const VATFlag = useSelector(state => state.globalReducer.VATFlag);
    const {switchVat} = useVAT();
    const [value, setValue] = useState(VATFlag);

    useEffect(() => {
        setValue(VATFlag)
    }, [VATFlag])

    const handleChange = (e, checked) => {
        setValue(checked);
        switchVat(checked)
    }

    return (
        <SwitchDetailedLabel 
            value={value}
            onChange={handleChange}
            {...props}
        />
    )
}
